(function () {
  const CW = window.CandlyWish || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function money(cents) {
    const fmt = (CW.moneyFormat || '£{{amount}}');
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* Mobile menu */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-menu-open]');
    const close = e.target.closest('[data-menu-close]');
    const ov = $('#MenuDrawer');
    if (open && ov) { ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('[data-menu-close]', ov)?.focus(); }
    if ((close || e.target === ov) && ov) { ov.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* Mega menu (hover + keyboard) */
  function initMega() {
    $$('[data-mega-trigger]').forEach((t) => {
      const nav = t.closest('.nav-desktop');
      const mega = nav && $('.mega', nav);
      if (!mega) return;
      t.addEventListener('mouseenter', () => mega.classList.add('is-open'));
      t.addEventListener('focusin', () => mega.classList.add('is-open'));

      mega.addEventListener('mouseenter', () => mega.classList.add('is-open'));
      mega.addEventListener('mouseleave', () => {
        setTimeout(() => mega.classList.remove('is-open'), 100);
});
      
      $$('[data-mega-close]', nav).forEach((o) => o.addEventListener('mouseenter', () => mega.classList.remove('is-open')));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') mega.classList.remove('is-open'); });
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    if (!document.body.classList.contains('cw-reveal-on') || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { threshold: 0.12 });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  }

  /* Cart */
  const drawer = () => $('#CartDrawer');
  function setCount(n) { $$('[data-cart-count]').forEach((el) => { el.textContent = n || ''; el.dataset.count = n; }); }
  async function getCart() { const r = await fetch('/cart.js'); return r.json(); }

  function renderCart(cart) {
    setCount(cart.item_count);
    const d = drawer(); if (!d) return;
    const body = $('[data-cart-body]', d);
    const foot = $('[data-cart-foot]', d);
    if (!cart.item_count) {
      body.innerHTML = `<p class="text-muted" style="margin-top:1rem">${d.dataset.emptyText}</p><a href="/collections/all" class="btn-cw" style="margin-top:1.5rem">${d.dataset.shopText}</a>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        <a href="${it.url}">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="${(it.product_title || '').replace(/"/g, '&quot;')}" loading="lazy">` : ''}</a>
        <div>
          <a href="${it.url}" class="line__title">${it.product_title}</a>
          ${it.variant_title ? `<p class="line__meta">${it.variant_title}</p>` : ''}
          <div class="qty" style="margin-top:.5rem">
            <button type="button" aria-label="Decrease" data-line="${i + 1}" data-qty="${it.quantity - 1}">−</button>
            <input type="text" value="${it.quantity}" readonly aria-label="Quantity">
            <button type="button" aria-label="Increase" data-line="${i + 1}" data-qty="${it.quantity + 1}">+</button>
          </div>
          <button type="button" class="line__remove" data-line="${i + 1}" data-qty="0">Remove</button>
        </div>
        <p>${money(it.final_line_price)}</p>
      </div>`).join('');
    $('[data-cart-subtotal]', d).textContent = money(cart.total_price);
  }

  function openCart() { const d = drawer(); if (!d) return; d.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('[data-cart-close]', d)?.focus(); }
  function closeCart() { const d = drawer(); if (!d) return; d.classList.remove('is-open'); document.body.style.overflow = ''; }

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && CW.cartType === 'drawer') { e.preventDefault(); renderCart(await getCart()); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === drawer()) { closeCart(); return; }
    const q = e.target.closest('#CartDrawer [data-line]');
    if (q) {
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: +q.dataset.qty }) });
      renderCart(await r.json());
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); $('#MenuDrawer')?.classList.remove('is-open'); document.body.style.overflow = ''; } });

  /* Product form */
  function initProduct(root) {
    const form = $('form.product-form', root); if (!form) return;
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-add-btn]', form);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);

    function current() {
      const sel = $$('[data-option-index]', root).map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      return data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }
    function update() {
      const v = current();
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (priceEl) priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '') + money(v.price);
      if (stockEl) stockEl.textContent = v.available ? '' : btn.dataset.soldout;
      if (v.featured_media) { const img = $(`[data-media-id="${v.featured_media.id}"]`, root); img?.click(); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    $$('[data-option-index] input', root).forEach((i) => i.addEventListener('change', update));

    $$('[data-qty-step]', form).forEach((b) => b.addEventListener('click', () => {
      const inp = $('input[name="quantity"]', form); inp.value = Math.max(1, (+inp.value || 1) + +b.dataset.qtyStep);
    }));

    form.addEventListener('submit', async (e) => {
      if (CW.cartType !== 'drawer') return;
      e.preventDefault();
      btn.disabled = true;
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      btn.disabled = false;
      if (!r.ok) { const err = await r.json(); alert(err.description || 'Could not add to basket'); return; }
      renderCart(await getCart()); openCart();
    });

    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      const main = $('[data-main-image]', root);
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
      $$('[data-thumb]', root).forEach((x) => x.classList.toggle('is-active', x === t));
    }));
  }

  /* Collection sort */
  function initSort() {
    $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('sort_by', s.value); location.href = url;
    }));
  }

  function init() { initMega(); initReveal(); initSort(); $$('[data-product-section]').forEach(initProduct); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', (e) => { initMega(); initReveal(); $$('[data-reveal]', e.target).forEach((el) => el.classList.add('is-visible')); $$('[data-product-section]', e.target).forEach(initProduct); });
})();
